'use strict';

module.exports = function ($uibModal, $state, $scope, departments, dialog, Department, myTenant, toast, gridConfiguration, $translate) {
    var _this = this;
    this.department = departments.filter(function (department) {
        return department.id === $state.params.departmentId;
    })[0];
    this.selectedMembers = [];

    _this.myTenant = myTenant;
    this.selectedMembers = [];
    this.loadingTasks = true;
    $scope.setRepeat = false;

    $scope.processContent = function ($fileContent) {
        $scope.content = $fileContent;
    };

    this.getMembers = function (query) {
        var scope = {};

        if (query) {
            scope = {
                where: {
                    or: [{
                        email: {
                            regexp: '/^' + query + '/i'
                        }
                    }, {
                        firstName: {
                            regexp: '/' + query + '/i'
                        }
                    }, {
                        lastName: {
                            regexp: '/' + query + '/i'
                        }
                    }]
                }
            };
        }

        return Department.teams({
            id: $state.params.departmentId,
            filter: {
                include: {
                    relation: 'members',
                    scope: scope
                }
            }
        })
            .$promise
            .then(function (teams) {
                var members = teams.reduce(function (memberList, team) {
                    //we add the first team, easy peasy.
                    if (!memberList.length) {
                        memberList = memberList.concat(team.members);
                    }

                    //remaining teams, we check if the member is already on the list
                    team.members.forEach(function (member) {
                        for (var i = 0; i < memberList.length; i++) {
                            if (member.id === memberList[i].id) {
                                return;
                            }
                        }
                        //we return the list for next iteration
                        memberList.push(member);
                    });

                    return memberList;

                }, []);
                return members;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.exportRows = function () {
        _this.gridOptions.api.exportDataAsCsv({
            fileName: 'tareas.csv'
        });
    }

    this.showImportFile = function () {
        $uibModal.open({
            animation: true,
            controller: [                
                "$state"
                , 'Authentication',
                function ($state, Authentication) {
                    this.Authentication = Authentication;
                    $state.importTasks = {};
                    $state.go('dashboard.departments.department.tasksAdvanced.import1');
                }
            ],
            templateUrl: "dashboard-tasks-advanced/importFileModal.html",
            controllerAs: "modalImport",
            size: "xlg",
            windowClass: "dialog",
            bindToController: true
        });
    };

    this.addUsers = function () {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', 'currentSelected',
                function ($uibModalInstance, currentSelected) {
                    this.members = [];
                    this.replaceMembers = false;
                    this.currentTeamMembers = []
                    if (currentSelected.length == 1)
                        this.currentTeamMembers = currentSelected[0].member;
                    var _this = this;
                    this.loading = false;

                    this.addUsers = function () {
                        if (!_this.members.length) {
                            return;
                        }
                        _this.loading = true;
                        //return { replace: _this.replaceMembers, members: _this.members }

                        _this.aProcesar = currentSelected.length;

                        currentSelected.map(function (task) {
                            //let task = currentSelected[0];
                            let members = [].concat(_this.members)

                            if (!_this.replaceMembers && task.member) {
                                members = members.concat(task.member);
                            }

                            var payload = {
                                task: task,
                                userIds: members.map(function (member) {
                                    return member.id;
                                })
                            };

                            payload.task.endDate = new Date(payload.task.endDate);
                            payload.task.startDate = new Date(payload.task.startDate);
                            delete payload.task.tenantId;
                            Department.updateTask({
                                departmentId: $state.params.departmentId
                            }, payload)
                                .$promise
                                .then(function (task) {
                                    _this.loading = false;
                                    _this.aProcesar--;
                                    if (_this.aProcesar == 0) {
                                        $uibModalInstance.close(true);
                                    }
                                })
                                .catch(function (error) {
                                    _this.loading = false;
                                    console.log(error);
                                    $uibModalInstance.close(true);
                                });
                        });
                    };
                }
            ],
            templateUrl: 'dashboard-tasks-advanced/dashboardAddUsersModal.html',
            controllerAs: 'modal',
            size: 'md',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
                currentSelected: function () {
                    // console.log('user _this.gridOptions', _this.gridOptions);
                    return _this.gridOptions.api.getSelectedRows();
                }

            }
        }).result.then(function () {
            $scope.filtrarRegistros()
        });
    };

    this.deleteTasks = function () {
        dialog.confirm({
            title: $translate.instant('DASHBOARD.DASH_TASKS.DIAG_DEL.TITLE'),
            body: $translate.instant('DASHBOARD.DASH_TASKS.DIAG_DEL.BODY'),
            accept: $translate.instant('DASHBOARD.DELETE'),
            cancel: $translate.instant('DASHBOARD.CANCEL'),
            size: 'sm'
        }).then(function () {
            toast.loading("Borrando...", "deleteTasks");
            let currentSelected = _this.gridOptions.api.getSelectedRows();
            _this.aProcesar = currentSelected.length;
            let lstIds = []
            currentSelected.map(function (task) {
                lstIds.push(task.id)
            });
            Department.deleteTasks({
                departmentId: $state.params.departmentId
            }, { tasksId: lstIds })
                .$promise.then(function (e, v) {
                    $scope.filtrarRegistros()
                    toast.closeLoaders("deleteTasks");
                });

        })
            .catch(function (error) {
                console.log(error);
            });
    };

    function initCalendario() {
        function formatYYYYMMDD(d) {
            return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        }

        $scope.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1
        };

        $scope.status = {
            opened: false
        };
        $scope.openCalendario = function ($event, obj) {
            $scope.status[obj] = true;
        };

        $scope.formats = ['dd-MMMM-yyyy', 'yyyy-MM-dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[1];
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.fechaHasta = new Date();
        $scope.fechaDesde = new Date();
        $scope.fechaDesde.setDate($scope.fechaDesde.getDate() - (5));
        $scope.fechaHasta.setDate($scope.fechaHasta.getDate() + (90));
        $scope.filtrarRegistros = function () {
            _this.loadingTasks = true;
            toast.loading($translate.instant("DASHBOARD.LOADING"), "loadTasks");
            let fDesde = formatYYYYMMDD($scope.fechaDesde);
            let fHasta = formatYYYYMMDD($scope.fechaHasta);
            let setRepite = $scope.setRepeat;
            let where = {
                "or": [
                    {
                        "startDate": {
                            "between": [
                                new Date(fDesde).toISOString().substr(0, 10) + "T00:00:00.000Z",
                                new Date(fHasta).toISOString().substr(0, 10) + "T23:59:59.000Z"
                            ]
                        }
                    }
                ]
            }

            if ($scope.setRepite) {
                where.or.push({
                    "and": [
                        {
                            "startDate": {
                                "lte": new Date(fHasta).toISOString().substr(0, 10) + "T23:59:59.000Z"
                            }
                        },
                        { "repeat": true },
                        {
                            "or": [
                                { "repeatData.repeatTill": null },
                                {
                                    "repeatData.repeatTill": {
                                        "lte": new Date(fHasta).toISOString().substr(0, 10) + "T23:59:59.000Z"
                                    }
                                }
                            ]
                        }
                    ]
                })
            }

            Department.task({
                id: $state.params.departmentId,
                filter:
                {
                    "include": [{
                        "relation": "member"
                    },
                    {
                        "relation": "client"
                    },
                    {
                        "relation": "form"
                    },
                    {
                        "relation": "item"
                    }
                    ],
                    "where": where
                }

            }).$promise
                .then(function (tasks) {
					_this.items = tasks;
					_this.columnDefs = [].concat(_this.columnDefsBase);
					var lstMetaColumns = [];

					// console.log('_this.items', _this.items);
					_this.items.forEach(item => {
						item.payload.forEach(payload => {
							// console.log('item.payload', payload);
							if (payload && payload.key) {
								if (lstMetaColumns.indexOf(payload.key.toUpperCase()) == -1) {
									lstMetaColumns.push(payload.key.toUpperCase());
								}
							}
						})
					});

					lstMetaColumns.forEach(col => {
						_this.columnDefs.push({
							headerName: "META:" + col,
							field: col,
							valueGetter: getPayload,
							width: 200
						});
					});

					_this.gridOptions.api.setColumnDefs(_this.columnDefs);
					_this.gridOptions.api.setRowData(_this.items);
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(function () {
                    _this.loadingTasks = false;
                    toast.closeLoaders("loadTasks");
                });

        };
    }

    initCalendario();

    $scope.filtrarRegistros()

    function getPayload(params) {
        if (params.data.payload && params.data.payload.length > 0) {
            var ret = params.data.payload.find(x => { 
                return x.key.toUpperCase() == params.colDef.field
                // return x ? ( x.key ? (x.key.toUpperCase() == params.colDef.field) : false ) : false
            })
            return ret ? ret.value : "";
        }
        return "0";
    }

    function getUsers(params) {
        if (params.data.member && params.data.member.length > 0) {
            var users = []
            params.data.member.forEach(u => { users.push(u.firstName + ' ' + u.lastName); });
            return users;
        }
        return [''];
    }

    function openDetail(obj) {
        if (obj.data.item.length > 0)
            //return '<a class="btn" role="button" ng-click="ctrl.showItems(data);"><i class="glyphicon glyphicon-list-alt"></i> ' + obj.data.item.length + '</a>';
            return obj.data.item.length  +  '<a class="btn" style="padding: 6px 4px" role="button" ng-click="ctrl.showItems(data);"><i class="glyphicon glyphicon-list-alt"></i></a> <a href ui-sref=\'dashboard.departments.department.forms.form.data({formId:"' + obj.data.formId + '",isFromTask:true})\' class="btn"  style="padding: 6px 4px" target="_blank"><i class="icon ion-stats-bars"></i></a>';
        else
            return '';
    }


    _this.columnDefsBase = [
        {
            headerCellRenderer: gridConfiguration.selectAllRenderer,
            field: "",
            checkboxSelection: true,
            width: 50,
            suppressMenu: true,
            suppressSorting: true,
            pinned: 'left',
            suppressResize: true
        },
        {
            headerName: $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.COLS.START'),
            field: 'startDate',
            cellRenderer: gridConfiguration.timestampRenderer,
            valueGetter: gridConfiguration.timestampGetter2,
            filter: gridConfiguration.dateFilter,
            comparator: gridConfiguration.dateComparator,
            width: 170
        },
        {
            headerName: $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.COLS.END'),
            field: 'endDate',
            cellRenderer: gridConfiguration.timestampRenderer,
            valueGetter: gridConfiguration.timestampGetter2,
            filter: gridConfiguration.dateFilter,
            comparator: gridConfiguration.dateComparator,
            width: 170
        },
        {
            headerName: $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.COLS.TASK_NAME'),
            field: 'name',
            width: 200
        },
        {
            headerName: $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.COLS.CLIENT'),
            field: 'client.name',
            width: 160
        },
        {
            headerName: $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.COLS.FORM'),
            field: 'form.name',
            width: 200
        },
        {
            headerName: "ITEMS",
            field: 'item.length',
            cellRenderer: openDetail,
            width: 80
        },
        {
            headerName: $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.COLS.DESCRIPTION'),
            field: 'description',
            width: 200
        },
        {
            headerName: $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.COLS.USERS'),
            field: 'member',
            valueGetter: getUsers,
            width: 200
        },
        {
            headerName: $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.COLS.REPEAT'),
            field: 'repeat',
            filter: "set",
            filterParams: { values: [true, false] },
            cellRenderer: gridConfiguration.checkboxRenderer,
            width: 80
        },
        {
            headerName: $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.COLS.TYPE'),
            field: 'repeatData.repeatType',
            width: 100
        }


    ];
    _this.columnDefs = [].concat(_this.columnDefsBase)

    _this.items = [];


    this.selectAllStatus = false;
    this.selectAll = function (status) {
        if (status) {
            _this.gridOptions.api.forEachNodeAfterFilterAndSort(function (node) {
                _this.gridOptions.api.selectNode(node, true);
            });
            return;
        }
        _this.gridOptions.api.deselectAll();

        return;
    };

    _this.showItems = function (row) {
        if (row.item.length == 0) {
            return;
        }
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', 'currentSelected', "$serverData", "$sce",
                function ($uibModalInstance, currentSelected, $serverData, $sce) {
                    console.log(currentSelected)
                    var _this = this;
                    this.task = currentSelected;
                    this.itemSelected = null;
                    if (this.task.item.length > 0)
                        this.itemSelected = this.task.item[0].id;

                    this.getTitle = function (item) {

                        let dia = new Date(item._startedAt).toISOString().substr(0, 10) + ' ' + new Date(item._startedAt).toLocaleTimeString().substr(0, 11);

                        let member = _this.task.member.find(function (member) {
                            if (member.id == item.memberId)
                                return member;
                        });

                        return member ? dia + " | " + member.firstName + " " + member.lastName : dia;
                    }

                    this.getURL = function () {
                        return $sce.trustAsResourceUrl("".concat($serverData.server, '/departments/', $state.params.departmentId, "/forms/", _this.task.formId, "/html/", _this.itemSelected));
                    }
                }
            ],
            templateUrl: 'dashboard-tasks-advanced/dashboardItemsModal.html',
            controllerAs: 'modal',
            size: 'lg',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
                currentSelected: function () {
                    return row;
                }

            }
        }).result.then(function () {});
    };

    _this.gridOptions = {
        pageSize: 1000,
        columnDefs: _this.columnDefs,
        debug: false,
        rowBuffer: 0,
        rowData: _this.items,
        rowHeight: 25,
        rowSelection: 'multiple',
        enableSorting: true,
        enableFilter: true,
        enableColResize: true,
        angularCompileRows: true,
        angularCompileFilters: true,
        angularCompileHeaders: true,
        headerHeight: 40,
        onSelectionChanged: function (selection) { _this.items = selection.selectedRows; },
        onBeforeFilterChanged: function () { console.log('onBeforeFilterChanged'); },
        onAfterFilterChanged: function () { console.log('onAfterFilterChanged'); },
        onFilterModified: function () { console.log('onFilterModified'); },
        onRowDoubleClicked: function (row) { _this.showItems(row.data); }

    };
};
